/**
 * Auto Form Disclosure and Attestation Wrapper
 * Wraps the shared DisclosureAndAttestation component with auto-specific configuration
 */

import SharedDisclosureAndAttestation from 'views/shared/DisclosureAndAttestation';
import FormInput from 'components/fields/auto/FormInput';
import { SECTIONS } from 'views/auto_form/constants';
import useIsBinderDisabled from 'hooks/useFormBinderDisabled';

const DisclosureAndAttestation = () => {
  const isDisabled = useIsBinderDisabled('autoPersonalForm');

  return (
    <SharedDisclosureAndAttestation
      formStateKey="autoPersonalForm"
      section={SECTIONS.DISCLOSURE_AND_ATTESTATION}
      FormInput={FormInput}
      isLocked={isDisabled}
    />
  );
};

export default DisclosureAndAttestation;
